
import {store} from '../../MainApp'
import {isEmpty} from 'lodash'

const ParseFloat = (Value) => {
  const regex = /[^0-9,\.,\-]/g;

  Value = String(Value).replace(regex, "")

  let _value = parseFloat(String(Value).replace(/,/g, '.'))

  return isNaN(_value) ? 0 : _value
}


//returnValue
//default === ValueInNotyfile
//currency === valuta

export const NumberFormat = (value, notation = 'standard', returnValue = 'currency', maximumFractionDigits = 2, minimumFractionDigits = 0, currencyOverride) => {

  try { 

    const locales = !isEmpty(store.getState().accountsData.Flags) ? store.getState().accountsData.Flags.locales : 'sv-SE'
    let currency = !isEmpty(store.getState().accountsData.Flags) ?store.getState().accountsData.Flags.currency : 'SEK'
    const ValueInNotyfile = !isEmpty(store.getState().accountsData.Flags) ?store.getState().accountsData.Flags.ValueInNotyfile : 1
    const Valuta = !isEmpty(store.getState().accountsData.Flags) ?store.getState().accountsData.Flags.Valuta : "st"

		if(currencyOverride) currency = currencyOverride

		if(ParseFloat(value) > 1000000 && notation === "compact"){
			maximumFractionDigits	= maximumFractionDigits < 1 ? 1 : maximumFractionDigits  
		}
    
    if((parseInt(ValueInNotyfile) === 2 && returnValue === 'default') || (returnValue === 'default' && notation==="total")) {
      return `${new Intl.NumberFormat(locales).format(ParseFloat(value))} ${Valuta}`
    }

      
    let currencyReturnValue = new Intl.NumberFormat(locales, {style: "currency", currency, notation, currency, minimumFractionDigits, maximumFractionDigits, }).format(ParseFloat(value))

    currencyReturnValue = currencyReturnValue.replace(/tn\skr/g, 'tkr')
    currencyReturnValue = currencyReturnValue.replace(/mn\skr/g, 'mkr')

    return currencyReturnValue
  } catch (err){
    console.log(err)
    return value
  }
}